import React from "react";

import {
  Typography,
  IconButton,
  Button,
  Dialog,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  makeStyles,
} from "@material-ui/core/";
import clsx from "clsx";
import Styles from "../../../Styles.module.css";

const styles = makeStyles((theme) => ({
  selectedIcon: {
    fontWeight: "bold",
    backgroundColor: "#FA7E61",
  },
  nonSelectedIcon: {
    backgroundColor: "white",
  },
  default: {
    marginLeft: 7,
    padding: "1px 12px 1px 12px",
    borderRadius: "4px",
    fontWeight: "bold",
  },
  selectedText: {
    color: "#FA7E61",
  },
  defaultText: {
    color: "white",
  },
}));

export default function SPUploadStepsHeader({ activeSection }) {
  const classes = styles();

  return (
    <Grid
      item
      xs={12}
      className={Styles.primaryBackground}
      style={{ height: 60, display: "flex", alignItems: "center" }}
    >
      <List style={{ width: "100%" }}>
        <Grid container style={{ padding: "2px 10%" }}>
          <Grid item xs={4}>
            <ListItem
              button
              className={clsx({
                [classes.selectedText]: activeSection === 1,
                [classes.defaultText]: activeSection !== 1,
              })}
              style={{ cursor: "default" }}
            >
              <ListItemIcon>
                <span
                  className={clsx(classes.default, Styles.navyBlueColor, {
                    [classes.selectedIcon]: activeSection === 1,
                    [classes.nonSelectedIcon]: activeSection !== 1,
                  })}
                >
                  1
                </span>
              </ListItemIcon>
              <ListItemText
                primary="Select & Upload"
                primaryTypographyProps={{ variant: "inherit" }}
              />
            </ListItem>
          </Grid>
          <Grid item xs={4}>
            <ListItem
              button
              className={clsx({
                [classes.selectedText]: activeSection === 2,
                [classes.defaultText]: activeSection !== 2,
              })}
              style={{ cursor: "default" }}
            >
              <ListItemIcon>
                <span
                  className={clsx(classes.default, Styles.navyBlueColor, {
                    [classes.selectedIcon]: activeSection === 2,
                    [classes.nonSelectedIcon]: activeSection !== 2,
                  })}
                >
                  2
                </span>
              </ListItemIcon>
              <ListItemText
                primary="Select Contacts"
                primaryTypographyProps={{ variant: "inherit" }}
              />
            </ListItem>
          </Grid>
          <Grid item xs={4}>
            <ListItem
              button
              className={clsx({
                [classes.selectedText]: activeSection === 3,
                [classes.defaultText]: activeSection !== 3,
              })}
              style={{ cursor: "default" }}
            >
              <ListItemIcon>
                <span
                  className={clsx(classes.default, Styles.navyBlueColor, {
                    [classes.selectedIcon]: activeSection === 3,
                    [classes.nonSelectedIcon]: activeSection !== 3,
                  })}
                >
                  3
                </span>
              </ListItemIcon>
              <ListItemText
                primary="Review and Send"
                primaryTypographyProps={{ variant: "inherit" }}
              />
            </ListItem>
          </Grid>
        </Grid>
      </List>
    </Grid>
  );
}
